import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Geetha M R</h3>
          <p>Your Trusted Financial Professional & Insurance Agent</p>
          <p>
            Helping families and businesses protect their future with
            comprehensive insurance solutions.
          </p>
        </div>

        <div className="footer-section">
          <h4>Contact Information</h4>
          <p>
            <i className="fas fa-phone"></i> Phone: +91 93410 15523
          </p>
          <p>
            <i className="fas fa-envelope"></i> Email: geetha1212@gmail.com
          </p>
          <p>
            <i className="fas fa-map-marker-alt"></i>28, Mahatma Gandhi Road
            Bangalore Karnataka 560001
          </p>
        </div>

        <div className="footer-section">
          <h4>Business Hours</h4>
          <p>Monday - Friday: 9:00 AM - 6:00 PM</p>
          <p>Saturday: 10:00 AM - 4:00 PM</p>
          <p>Sunday: Closed</p>
        </div>

        <div className="footer-section">
          <h4>License Information</h4>
          <p>IRDAI Registration Number : ILGDxxx15203/ 60125817</p>
          <p>State: Karnataka</p>
          <p>Fully Licensed & Insured</p>
        </div>

        <div className="footer-section">
          <h4>
            Follow us on{" "}
            <a
              href="https://www.instagram.com/_geetha_surendra"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </h4>

          <div className="social-links">
            {/* <a
              href="https://facebook.com/vijaymd"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-facebook-f"></i>
            </a> */}
            {/* <a
              href="https://twitter.com/vijaymd"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
            <a
              href="https://linkedin.com/in/vijaymd"
              className="social-link"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p style={{ textAlign: "left" }}>
            Disclaimer: An insurance advisor disclaimer clarifies that general
            info isn't personalized advice, stresses users must check policy
            details, notes risks (like investment losses on funds), and states
            the advisor/website isn't liable for decisions or claim outcomes,
            emphasizing the contract is with the insurer, requiring consultation
            with a qualified professional for specific needs. Key points include
            "subject to terms & conditions," "consult a professional," "past
            performance isn't future results," and that "insurance products are
            obligations of the insurer only.
          </p>
          <p>&copy; 2026 Geetha M R Insurance Services. All rights reserved.</p>
          {/* <div className="footer-links">
            <a href="#contact">Privacy Policy</a>
            <a href="#contact">Terms of Service</a>
            <a href="#contact">Disclaimer</a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
